// The first breathe starts 3.5s after the first sheen (SHEEN_FIRST_DELAY_MS),
// and they repeat every 7s, so two fall midway between each pair of 14s
// sheens: 2s after one ends and 1.75s before the next starts.
export const BREATHE_FIRST_DELAY_MS = 6500;
export const BREATHE_INTERVAL_MS = 7000;
export const BREATHE_RETRY_MS = 250;


/**
 * Decides when the quick-play button breathes: first after a delay, then
 * a fixed interval after each one started. A breathe waits, retrying,
 * while isClearFor says it would come near a sheen, such as one a hover
 * started or moved.
 */
export class BreatheScheduler {
    private readonly durationMs: number;
    private readonly onStart: () => void;
    private readonly onEnd: () => void;
    private readonly isClearFor: (durationMs: number) => boolean;
    private timer: ReturnType<typeof setTimeout> | null = null;

    constructor(
        durationMs: number,
        onStart: () => void,
        onEnd: () => void,
        isClearFor: (durationMs: number) => boolean,
    ) {
        this.durationMs = durationMs;
        this.onStart = onStart;
        this.onEnd = onEnd;
        this.isClearFor = isClearFor;
    }

    begin(): void {
        this.schedule(this.tryStart, BREATHE_FIRST_DELAY_MS);
    }

    stop(): void {
        if (this.timer !== null)
            clearTimeout(this.timer);

        this.timer = null;
    }

    private schedule(action: () => void, delayMs: number): void {
        this.stop();
        this.timer = setTimeout(action, delayMs);
    }

    private readonly tryStart = (): void => {
        if (!this.isClearFor(this.durationMs)) {
            this.schedule(this.tryStart, BREATHE_RETRY_MS);
            return;
        }

        this.onStart();
        this.schedule(this.finish, this.durationMs);
    };

    private readonly finish = (): void => {
        this.onEnd();
        this.schedule(this.tryStart, BREATHE_INTERVAL_MS - this.durationMs);
    };
}
